import Bootable from '../bootable';
import { getObjectValueByPath } from '../../util/helpers';
import mixins from '../../util/mixins';
import { consoleWarn } from '../../util/console';
function validateAttachTarget(val) {
    const type = typeof val;
    if (type === 'boolean' || type === 'string')
        return true;
    return val.nodeType === Node.ELEMENT_NODE;
}
function removeActivator(activator) {
    activator.forEach(node => {
        node.elm && node.elm.parentNode && node.elm.parentNode.removeChild(node.elm);
    });
}
export default mixins(Bootable).extend({
    name: 'detachable',
    props: {
        attach: {
            default: false,
            validator: validateAttachTarget
        },
        contentClass: {
            type: String,
            default: ''
        }
    },
    data: () => ({
        activatorNode: null,
        hasDetached: false
    }),
    watch: {
        attach() {
            this.hasDetached = false;
            this.initDetach();
        },
        hasContent() {
            this.$nextTick(this.initDetach);
        }
    },
    beforeMount() {
        this.$nextTick(() => {
            if (this.activatorNode) {
                const activator = Array.isArray(this.activatorNode) ? this.activatorNode : [this.activatorNode];
                activator.forEach(node => {
                    if (!node.elm)
                        return;
                    if (!this.$el.parentNode)
                        return;
                    const target = this.$el === this.$el.parentNode.firstChild ? this.$el : this.$el.nextSibling;
                    this.$el.parentNode.insertBefore(node.elm, target);
                });
            }
        });
    },
    mounted() {
        this.hasContent && this.initDetach();
    },
    deactivated() {
        this.isActive = false;
    },
    beforeDestroy() {
        if (this.$refs.content && this.$refs.content.parentNode) {
            this.$refs.content.parentNode.removeChild(this.$refs.content);
        }
    },
    destroyed() {
        if (this.activatorNode) {
            const activator = Array.isArray(this.activatorNode) ? this.activatorNode : [this.activatorNode];
            if (this.$el.isConnected) {
                const observer = new MutationObserver(list => {
                    if (list.some(record => Array.from(record.removedNodes).includes(this.$el))) {
                        observer.disconnect();
                        removeActivator(activator);
                    }
                });
                observer.observe(this.$el.parentNode, {
                    subtree: false,
                    childList: true
                });
            }
            else {
                removeActivator(activator);
            }
        }
    },
    methods: {
        getScopeIdAttrs() {
            const scopeId = getObjectValueByPath(this.$vnode, 'context.$options._scopeId');
            return scopeId && {
                [scopeId]: ''
            };
        },
        initDetach() {
            if (this._isDestroyed || !this.$refs.content || this.hasDetached ||
                this.attach === '' ||
                this.attach === true ||
                this.attach === 'attach')
                return;
            let target;
            if (this.attach === false) {
                target = document.querySelector('[data-app]');
            }
            else if (typeof this.attach === 'string') {
                target = document.querySelector(this.attach);
            }
            else {
                target = this.attach;
            }
            if (!target) {
                consoleWarn(`Unable to locate target ${this.attach || '[data-app]'}`, this);
                return;
            }
            target.appendChild(this.$refs.content);
            this.hasDetached = true;
        }
    }
});
